module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOpenModal) ? _c('DModal', {
    staticClass: "d-modal standard-duration",
    attrs: {
      "showClose": false,
      "isBgOverlay": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.set_standard_duration_for_the_school')))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_for_the_school')))]), _vm._v(" "), _c('div', {
    staticClass: "input-minutes-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDuration),
      expression: "inputDuration"
    }],
    ref: "duration_input",
    attrs: {
      "type": "number",
      "id": "standard-duration-input",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.inputDuration)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDuration = $event.target.value
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.set_standard_duration.minutes')) + "\n        ")]), _vm._v(" "), (!_vm.isAValidDuration) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.set_standard_duration.the_number_must_be_divisible_by_five')) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.isForImportInZEN) ? _c('h4', {
    staticClass: "marg-2-top standard-duration__explained text-explainer"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.set_standard_duration.set_standard_length_for_zen')) + "\n      ")]) : _c('div', {
    staticClass: "marg-2-top"
  }, [_c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.this_setting_will_be_selected_if_nothing_else_is')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_can_be_selected_for_each_course')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.already_created_courses_want_be_updated')))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "marg-5-right",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isAValidDuration) ? _c('button', {
    staticClass: "submit-button submit-button--disabled"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")]) : _c('button', {
    staticClass: "submit-button submit-button--danger bttn bttn--primary",
    class: {
      'bttn--loading': _vm.isButtonLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70ad290a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/School/StandardDurationSetting.vue
// module id = 2002
// module chunks = 1